<!--
  ~ Copyright (c) 2019
  ~    Reliant Business Valuation, LLC - http://reliantvalue.com
  ~    Author: Kirill Vizniuk - kirill@internalvaluation.com
  ~
  ~ Licensed under the Apache License, Version 2.0 (the "License");
  ~ you may not use this file except in compliance with the License.
  ~ You may obtain a copy of the License at
  ~
  ~ http://www.apache.org/licenses/LICENSE-2.0
  ~
  ~ Unless required by applicable law or agreed to in writing, software
  ~ distributed under the License is distributed on an "AS IS" BASIS,
  ~ WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  ~ See the License for the specific language governing permissions and
  ~ limitations under the License.
  -->

<div class="modal-header">
  <h4 class="modal-title pull-left">Do you really want to <span style="color:red;">Delete</span> Report?</h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  <div class="row">

    <div class="col-sm-12 form-group" *ngIf="report">
      <label style="font-weight: normal;">
        Please enter
        <strong style="color: red;" *ngIf="report.hasPrimaryEntity()">{{report.primaryEntity()}}</strong>
        <strong style="color: red;" *ngIf="!report.hasPrimaryEntity()">{{report.ID}}</strong>
        to confirm deletion
      </label>

      <input type="text" [placeholder]="report.hasPrimaryEntity() ? report.primaryEntity() : report.ID"
             class="form-control" name="deleteName" [(ngModel)]="deleteName" />
    </div>

    <div class="col-sm-12 form-group" *ngIf="reports">
      <label style="font-weight: normal;">
        Please enter <strong style="color: red;">I Want to Delete Reports</strong>
        to confirm deletion <br/><i>NOTICE: Capital Symbols are mandatory</i>
      </label>
      <h5>Following Reports will be permanently Deleted:</h5>
      <ul>
        <li *ngFor="let dRep of reports">
          <strong>{{dRep.primaryEntity() ? dRep.primaryEntity() : "Company Name Not Selected"}}</strong> ID: {{dRep.ID}}
        </li>
      </ul>

      <input type="text" placeholder="I Want to Delete Reports" class="form-control" name="deleteName" [(ngModel)]="deleteName" />
    </div>

  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
  <button class="btn btn-rbv warning" (click)="onConfirm()" *ngIf="report && !reports"
          [disabled]="deleteName != report?.primaryEntity() && (deleteName != report?.ID+'')">
    Delete
  </button>
  <button class="btn btn-rbv warning" (click)="onConfirm()" *ngIf="!report && reports"
          [disabled]="deleteName !== 'I Want to Delete Reports'">
    Delete
  </button>
</div>
